import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../../Config/Loader.css';
import Base1 from '../../Config/Base1';
import { fetchWithAuth } from "../../../utils/api";
import Swal from 'sweetalert2';
import { useLocation } from "react-router-dom";
import { Dropdown, Menu, message, Modal, Tooltip, Select } from 'antd';
import KpiModal from './kpiModel';
import { getKPIs, getManagerKPIs, manageKPI, getChildKPIs } from '../services/kpiServices';
import KpiEditModal from './KpiEditModal';

export default function KPIMaster() {

    const navigate = useNavigate();
    const location = useLocation();
    const [sessionUserData, setsessionUserData] = useState({});
    const [sessionActionIds, setSessionActionIds] = useState([]);
    const [modules, setModules] = useState([]);
    const [menuData, setMenuData] = useState([]);
    const [activeTab, setActiveTab] = useState("");
    const [openCreateKPI, setOpenCreateKPI] = useState(false);
    const [organizationKPIData, setOrganizationKPIData] = useState([]);
    const [allManagerKpis, setAllManagerKpis] = useState([]);
    const [managerKpis, setManagerKpis] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [uomTypes, setUOMTypes] = useState([]);
    const [sessionModuleId, setSessionModuleId] = useState(null);
    const [selectedMainDept, setSelectedMainDept] = useState(null);
    const [selectedKPI, setSelectedKPI] = useState(null);
    const [childKpisMap, setChildKpisMap] = useState({});
    const [departments, setDepartments] = useState([]);
    const [selectedDeptId, setSelectedDeptId] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [deleteKPI, setDeleteKPI] = useState(null);
    const [saving, setSaving] = useState(false);
    const [selectedParentKPIId, setSelectedParentKPIId] = useState(null);
    const [openChildTab, setOpenChildTab] = useState(false);
    const [selectedParentUOMId, setSelectedParentUOMId] = useState(null);
    const [recordsPerPage, setRecordsPerPage] = useState(8);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [showCurrentPeriodOnly, setShowCurrentPeriodOnly] = useState(true);
    const [expandedRows, setExpandedRows] = useState(new Set());
    const [kpiView, setKpiView] = useState("department");
    // Search
    const [parentKpiSearch, setParentKpiSearch] = useState("");

    // Pagination
    const [parentKpiPage, setParentKpiPage] = useState(1);
    const parentKpiRecordsPerPage = 5;

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setsessionUserData(userData);

            const storedModule = JSON.parse(localStorage.getItem("ModuleData"));
            const moduleId = storedModule?.Id?.toString();
            setSessionModuleId(moduleId);
            setSelectedMainDept(userData?.DeptId);
        } else {
            navigate("/");
        }
    }, [navigate]);

    useEffect(() => {
        const sessionMenuData = sessionStorage.getItem("menuData");
        try {
            const parsedMenu = JSON.parse(sessionMenuData);
            setMenuData(parsedMenu)
            const dashboardMenu = parsedMenu.find(
                (item) => item.MenuName === "KPI Master"
            );

            let actionIds = [];
            if (dashboardMenu?.ActionsIds) {
                actionIds = actionIds.concat(
                    dashboardMenu.ActionsIds.split(",").map(Number)
                );
            }

            if (actionIds.length > 0) {
                const uniqueActionIds = [...new Set(actionIds)];
                setSessionActionIds(uniqueActionIds);
            }
        } catch (err) {
            console.error("Error parsing menuData:", err);
        }
    }, []);

    const fetchMenuData = async () => {
        try {
            // First check if accessModules already exists in sessionStorage
            const sessionAccessModules = sessionStorage.getItem("accessModules");

            if (sessionAccessModules) {
                // ✅ If already cached, just parse and set directly
                setModules(JSON.parse(sessionAccessModules));
                return; // stop further execution
            }

            // 🚀 Else fetch from API
            const response = await fetchWithAuth("auth/getModules", {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });

            if (response.ok) {
                const data = await response.json();
                const allModules = data.ResultData || [];

                // Get user access IDs
                const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
                const accessIds = userData?.AccessToModules
                    ? userData.AccessToModules.split(",").map(Number)
                    : [];

                // Filter modules by access
                const filteredModules = allModules.filter((mod) =>
                    accessIds.includes(mod.Id)
                );

                // Save to state
                setModules(filteredModules);

                // 🔥 Cache in sessionStorage for next time
                sessionStorage.setItem("accessModules", JSON.stringify(filteredModules));
            } else {
                console.error("Failed to fetch menu data:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching menu data:", error.message);
        }
    };

    useEffect(() => {
        if (sessionUserData?.OrgId) {
            fetchMenuData();
            setSelectedDeptId(sessionUserData?.DeptId);
        }
    }, [sessionUserData]);

    const handleModuleClick = async (mod) => {
        localStorage.setItem("ModuleData", JSON.stringify(mod));

        const sessionUserData = JSON.parse(sessionStorage.getItem("userData") || "{}");
        try {
            const response = await fetchWithAuth(`auth/getmenu?OrgId=${sessionUserData.OrgId}&RoleId=${sessionUserData.RoleId}&ModuleId=${mod.Id}&UserId=${sessionUserData.Id}`, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            }
            );

            if (response.ok) {
                const data = await response.json();
                const menuList = data.ResultData;

                if (menuList.length > 0 && menuList[0].MenuPath) {
                    sessionStorage.setItem("menuData", JSON.stringify(menuList));
                    sessionStorage.setItem("navigationPath", menuList[0].MenuPath);
                    navigate(menuList[0].MenuPath);
                } else {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Module unavailable',
                        text: 'You don’t have access to this module yet. Please contact your administrator for help.',
                        confirmButtonText: 'OK'
                    });
                    console.warn("No menu path available.");
                }
            } else {
                Swal.fire({
                    icon: 'warning',
                    title: 'Module unavailable',
                    text: 'You don’t have access to this module yet. Please contact your administrator for help.',
                    confirmButtonText: 'OK'
                });
                console.error("Failed to fetch menu data");
            }
        } catch (error) {
            console.error("Menu fetch error:", error);
        }
    };

    const fetchDDLData = async () => {
        try {
            const sessionDDL = sessionStorage.getItem("ddlKPIMasterData");

            if (sessionDDL) {
                const parsed = JSON.parse(sessionDDL);

                const filteredData = showDept
                    ? parsed.depts || []
                    : parsed.deptsByManager || [];

                setDepartments(filteredData);
                return;
            }

            const response = await fetchWithAuth(
                `ADMINRoutes/CWIGetDDLItems?OrgId=${sessionUserData?.OrgId}&UserId=${sessionUserData?.Id}`,
                {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                }
            );

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const data = await response.json();

            const deptsFilteredData = (data.ResultData || []).filter(
                (item) => item.DDLName === "Departments"
            );

            const managerDeptsFilteredData = (data.ResultData || []).filter(
                (item) => item.DDLName === "getdeptsByManager"
            );

            const filteredData = showDept
                ? deptsFilteredData
                : managerDeptsFilteredData;

            setDepartments(filteredData);

            sessionStorage.setItem(
                "ddlKPIMasterData",
                JSON.stringify({
                    depts: deptsFilteredData,
                    deptsByManager: managerDeptsFilteredData,
                })
            );

        } catch (error) {
            console.error("Failed to fetch DDL data:", error);
            setDepartments([]);
        }
    };

    const fetchKPIList = async () => {
        try {
            setLoading(true);
            const response = await getKPIs({
                orgId: sessionUserData?.OrgId,
                deptId: selectedMainDept,
                kpiLevel: 1,
                userId: sessionUserData?.Id,
            });

            setOrganizationKPIData(response?.data || []);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (activeTab === "organization" && sessionUserData?.OrgId) {
            fetchKPIList();
        }
    }, [activeTab, sessionUserData?.OrgId, selectedMainDept]);

    const fetchManagerKPIs = async () => {
        try {
            setLoading(true);

            const response = await getManagerKPIs({
                orgId: sessionUserData?.OrgId,
                employeeId: sessionUserData?.Id,
                deptId: selectedMainDept,
                periodId: showCurrentPeriodOnly
                    ? sessionUserData?.PeriodId
                    : 0,
            });

            const allKpis = response?.data || [];

            // Store complete API response
            setAllManagerKpis(allKpis);

        } catch (error) {
            console.error(error);

        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {

        if (sessionUserData?.Id && activeTab === "department") {
            fetchManagerKPIs();
        }

    }, [
        sessionUserData?.Id,
        sessionUserData?.OrgId,
        sessionUserData?.PeriodId,
        showCurrentPeriodOnly,
        selectedMainDept,
        activeTab
    ]);

    useEffect(() => {

        const userId = Number(sessionUserData?.Id);

        let filteredKpis = [];

        if (kpiView === "department") {

            filteredKpis = allManagerKpis.filter(
                (item) =>
                    Number(item.CreatedBy) !== userId
            );

        } else if (kpiView === "my") {

            filteredKpis = allManagerKpis.filter(
                (item) =>
                    Number(item.CreatedBy) === userId
            );
        }

        setManagerKpis(filteredKpis);

        // Reset pagination when switching tabs
        setCurrentPage(1);

    }, [
        kpiView,
        allManagerKpis,
        sessionUserData?.Id
    ]);

    const fetchChildKPIs = async (parentId) => {
        try {
            setLoading(true);

            const response = await getChildKPIs({
                orgId: sessionUserData?.OrgId,
                deptId: selectedMainDept,
                parentId,
            });

            setChildKpisMap(prev => ({
                ...prev,
                [parentId]: response?.data || [],
            }));
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const toggleRow = (parentId) => {
        const newExpanded = new Set(expandedRows);

        if (newExpanded.has(parentId)) {
            newExpanded.delete(parentId);
        } else {
            newExpanded.add(parentId);

            if (!childKpisMap[parentId]) {
                fetchChildKPIs(parentId);
            }
        }

        setExpandedRows(newExpanded);
    };

    // useEffect(() => {
    //     if (sessionUserData?.OrgId) {
    //         fetchManagerKPIs();
    //     }
    // }, [sessionUserData, showCurrentPeriodOnly]);

    useEffect(() => {
        if (selectedDeptId) {
            fetchKPIList();
        }
    }, [selectedDeptId]);

    const fetchMasterTypes = async () => {
        try {
            const response = await fetchWithAuth(
                `Portal/GetMasterTypes?OrgId=${sessionUserData?.OrgId}&DeptId=0&ModuleId=${sessionModuleId}&TypeCategory=4`,
                {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                }
            );

            if (!response.ok) throw new Error("Network response was not ok");

            const data = await response.json();
            setUOMTypes(data.ResultData || []);

        } catch (error) {
            console.error("Failed to fetch types data:", error);
            setUOMTypes([]);
        }
    };

    useEffect(() => {
        if (sessionUserData.OrgId) {
            fetchMasterTypes();
            fetchDDLData();
        }
    }, [sessionUserData]);

    const filteredParentKpis = Array.isArray(organizationKPIData)
        ? organizationKPIData
            // .filter((item) => {
            //     if (!showCurrentPeriodOnly) return true;
            //     return item.PeriodId === sessionUserData?.PeriodId;
            // })
            .filter((item) =>
                item.KPIName?.toLowerCase().includes(parentKpiSearch.toLowerCase())
            )
        : [];

    const parentKpiLastIndex = parentKpiPage * parentKpiRecordsPerPage;
    const parentKpiFirstIndex = parentKpiLastIndex - parentKpiRecordsPerPage;

    const parentKpiRecords = filteredParentKpis.slice(
        parentKpiFirstIndex,
        parentKpiLastIndex
    );

    const parentKpiTotalPages = Math.ceil(
        filteredParentKpis.length / parentKpiRecordsPerPage
    );

    const handleParentKpiPageChange = (page) => {
        setParentKpiPage(page);
    };

    const getParentKpiPageNumbers = () => {
        const pages = [];

        if (parentKpiTotalPages <= 7) {
            for (let i = 1; i <= parentKpiTotalPages; i++) {
                pages.push(i);
            }
        } else {
            if (parentKpiPage <= 4) {
                for (let i = 1; i <= 5; i++) pages.push(i);
                pages.push("...");
                pages.push(parentKpiTotalPages);
            } else if (parentKpiPage > parentKpiTotalPages - 4) {
                pages.push(1);
                pages.push("...");
                for (let i = parentKpiTotalPages - 4; i <= parentKpiTotalPages; i++) {
                    pages.push(i);
                }
            } else {
                pages.push(1);
                pages.push("...");
                for (let i = parentKpiPage - 1; i <= parentKpiPage + 1; i++) {
                    pages.push(i);
                }
                pages.push("...");
                pages.push(parentKpiTotalPages);
            }
        }

        return pages;
    };

    const filteredKpis = Array.isArray(managerKpis)
        ? managerKpis
            .filter((item) => {
                if (!showCurrentPeriodOnly) return true;

                return item.PeriodId === sessionUserData?.PeriodId;
            })
            .filter((item) => {
                const query = searchQuery.toLowerCase();

                return (
                    item.KPIName?.toLowerCase().includes(query)
                    // item.Objectives?.toLowerCase().includes(query)
                );
            })
        : [];

    // Update your pagination variables to use filteredKpis
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredKpis.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(filteredKpis.length / recordsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const threshold = 2; // How many pages to show around the current page

        if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
        } else {
            if (currentPage <= 4) {
                // Near the start: 1 2 3 4 5 ... 50
                for (let i = 1; i <= 5; i++) pageNumbers.push(i);
                pageNumbers.push('...');
                pageNumbers.push(totalPages);
            } else if (currentPage > totalPages - 4) {
                // Near the end: 1 ... 46 47 48 49 50
                pageNumbers.push(1);
                pageNumbers.push('...');
                for (let i = totalPages - 4; i <= totalPages; i++) pageNumbers.push(i);
            } else {
                // In the middle: 1 ... 14 15 16 ... 50
                pageNumbers.push(1);
                pageNumbers.push('...');
                for (let i = currentPage - 1; i <= currentPage + 1; i++) pageNumbers.push(i);
                pageNumbers.push('...');
                pageNumbers.push(totalPages);
            }
        }
        return pageNumbers;
    };

    const handleSaveKPI = async (data) => {
        setSaving(true);
        try {
            const payload = {
                Type: "ADD",
                OrgId: sessionUserData?.OrgId,
                UserId: sessionUserData?.Id,
                JsonData: data.map(item => ({
                    KPILevel:
                        activeTab === "organization"
                            ? 1
                            : selectedParentKPIId
                                ? 2
                                : 1,
                    RefId: item.refId,
                    UOMId: item.uom,
                    KPIName: item.KPIName,
                    Objectives: item.objective,
                    ParentId: activeTab === "organization"
                        ? null
                        : item.parentId,
                    PeriodId: sessionUserData?.PeriodId,
                    Measurables: item.Measurables,
                }))
            };

            const response = await manageKPI(payload);
            const result = response?.data?.result?.[0];

            if (result?.ResponseCode === 200) {
                message.success(
                    result?.Message || "KPI Created Successfully"
                );

                setOpenCreateKPI(false);
                fetchChildKPIs(selectedParentKPIId);
                fetchKPIList();

            } else if (result?.ResponseCode === 409) {
                message.warning(
                    result?.Message || "KPI already exists."
                );
            } else {
                message.error(
                    result?.Message || "Failed to save KPI"
                );
            }
        } catch (error) {
            console.error(error);
            message.error("Something went wrong");
        } finally {
            setSaving(false);
        }
    };

    const handleUpdateKPI = async (data) => {
        try {
            const payload = {
                Type: "EDIT",
                OrgId: sessionUserData?.OrgId,
                UserId: sessionUserData?.Id,
                JsonData: [
                    {
                        Id: data.Id,
                        KPILevel: activeTab === "organization" ? 1 : 2,
                        UOMId: data.UOM,
                        RefId: activeTab === "organization"
                            ? null
                            : data.DeptId,
                        KPIName: data.KPIName,
                        Objectives: data.Objectives,
                        Measurables: data.Measurables,
                        PeriodId: sessionUserData?.PeriodId,
                        ParentId: activeTab === "organization"
                            ? null
                            : data.ParentId,
                        RefId: data.RefId || selectedMainDept,
                    }
                ]
            };

            const response = await manageKPI(payload);
            const result = response?.data?.result?.[0];

            if (result?.ResponseCode === 200) {
                message.success(
                    result?.Message || "KPI Created Successfully"
                );

                setOpenEditModal(false);
                fetchKPIList();
                fetchChildKPIs(data.ParentId);

            } else if (result?.ResponseCode === 409) {

                message.warning(
                    result?.Message || "KPI already exists."
                );

            } else {

                message.error(
                    result?.Message || "Failed to save KPI"
                );
            }
        } catch (error) {
            console.error(error);
            message.error("Something went wrong");
        }
    };

    const handleDeleteKPI = async () => {
        if (!deleteKPI) return;

        setDeleteLoading(true);

        const payload = {
            Type: "INACTIVE",
            OrgId: sessionUserData.OrgId,
            UserId: sessionUserData.Id,
            JsonData: [
                {
                    Id: deleteKPI.Id,
                },
            ],
        };

        try {
            const response = await manageKPI(payload);

            if (
                response?.success &&
                response?.data?.result?.[0]?.ResponseCode === 200
            ) {
                message.success(response.data.result[0].Message);

                setDeleteKPI(null);
                fetchKPIList();
                fetchChildKPIs(deleteKPI.ParentId);
            } else {
                message.error(
                    response?.data?.result?.[0]?.Message || "Unable to delete KPI."
                );
            }
        } catch (err) {
            console.error(err);
            message.error("Something went wrong.");
        } finally {
            setDeleteLoading(false);
        }
    };

    const iconColors = ['#FF6B35', '#00B8D9', '#36B37E', '#FFAB00', '#6554C0', '#FF5630'];
    const showOrgTab = sessionActionIds?.includes(37);
    const showDeptTab = sessionActionIds?.includes(38);
    const showAdd = sessionActionIds?.includes(1);
    const showEdit = sessionActionIds?.includes(3);
    const showDelete = sessionActionIds?.includes(11);
    const showDept = sessionActionIds?.includes(25);

    useEffect(() => {
        if (showOrgTab) {
            setActiveTab("organization");
        } else if (showDeptTab) {
            setActiveTab("department");
        }
    }, [sessionActionIds]);

    const stripHtml = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html || "";
        return div.textContent || div.innerText || "";
    };

    return (
        <Base1>
            <div className="d-flex flex-column flex-column-fluid mb-12">
                <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                    <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                        <div className="page-title d-md-block d-none">
                            <div className="d-flex align-items-center gap-2">
                                <div className="dropdown d-inline-block me-2">
                                    <span
                                        className="menu-link bg-white shadow-sm me-2 dropdown-toggle"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        style={{ position: "relative", zIndex: 10 }}
                                    >
                                        <span className="menu-title">
                                            <i className="fa-solid fa-grip me-1"></i> Portal
                                        </span>
                                    </span>

                                    <ul className="dropdown-menu shadow">
                                        {modules.map((mod, index) => {
                                            const isActive = location.pathname
                                                .toLowerCase()
                                                .includes(mod.ModuleName.toLowerCase());

                                            return (
                                                <li
                                                    key={index}
                                                    className={`mb-1 ${isActive ? "active-module" : ""}`}
                                                >
                                                    <a
                                                        className="dropdown-item d-flex align-items-center gap-2 module-item"
                                                        onClick={() => handleModuleClick(mod)}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <i
                                                            className={`fas fa-${mod.ImageIcon}`}
                                                            style={{
                                                                color: iconColors[index % iconColors.length],
                                                                textShadow: "1px 1px 3px rgba(0,0,0,0.5)",
                                                            }}
                                                        ></i>
                                                        <span>{mod.ModuleName}</span>
                                                    </a>
                                                </li>
                                            );
                                        })}
                                        <li
                                            className="dropdown-item d-flex align-items-center gap-2 module-item"
                                            onClick={() => navigate("/user-modules")}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <i
                                                className="fa-solid fa-arrow-left"
                                                style={{
                                                    color: "#ffccbc",
                                                    textShadow: "1px 1px 3px rgba(0,0,0,0.5)",
                                                }}
                                            ></i>
                                            <span>Go Back to Portal</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="d-flex align-items-center">
                                    {menuData?.map((menu) => {
                                        const hasSubItems = menu.SubItems && menu.SubItems.length > 0;

                                        if (hasSubItems) {
                                            const subMenu = (
                                                <Menu className="shadow-sm border-0 rounded-3 mt-2">
                                                    {menu.SubItems.map((sub) => (
                                                        <Menu.Item key={sub.AppMenuId} className="p-3">
                                                            <a
                                                                href={sub.MenuPath.startsWith('/') ? sub.MenuPath : `/${sub.MenuPath}`}
                                                                className="text-gray-700 fw-bold text-decoration-none"
                                                            >
                                                                <i className="bi bi-arrow-return-right me-1"></i>
                                                                {sub.MenuName}
                                                            </a>
                                                        </Menu.Item>
                                                    ))}
                                                </Menu>
                                            );

                                            return (
                                                <Dropdown overlay={subMenu} trigger={['hover']} key={menu.AppMenuId}>
                                                    <span className="menu-link bg-white shadow-sm me-2 cursor-pointer border border-gray-100">
                                                        <span className="menu-title">
                                                            <i className={`${menu.IconName || 'bi bi-grid'} text-primary me-2`}></i>
                                                            {menu.MenuName}
                                                        </span>
                                                        <i className="bi bi-chevron-down ms-2 fs-9"></i>
                                                    </span>
                                                </Dropdown>
                                            );
                                        }
                                        return (
                                            <a
                                                key={menu.AppMenuId}
                                                href={menu.MenuPath}
                                                style={{ position: "relative", zIndex: 10, textDecoration: 'none' }}
                                            >
                                                <span className={`menu-link bg-white shadow-sm me-2 cursor-pointer ${window.location.pathname === menu.MenuPath ? 'active border-primary' : ''}`}>
                                                    <span className="menu-title text-gray-800">
                                                        <i className={`${menu.IconName} text-primary me-2`}></i>
                                                        {menu.MenuName}
                                                    </span>
                                                </span>
                                            </a>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>

                        <div className="page-title d-md-none d-block mb-3 mb-md-0">
                            <div className="d-flex align-items-center gap-2">
                                <div className="dropdown d-inline-block">
                                    <span
                                        className="menu-link bg-white shadow-sm me-2 dropdown-toggle"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        style={{ position: "relative", zIndex: 10 }}
                                    >
                                        <span className="menu-title">
                                            <i className="fa-solid fa-grip me-1"></i>
                                        </span>
                                    </span>

                                    <ul className="dropdown-menu shadow">
                                        {modules?.map((mod, index) => {
                                            const isActive = location.pathname.toLowerCase().includes(
                                                mod.ModuleName.toLowerCase()
                                            );

                                            return (
                                                <li
                                                    key={index}
                                                    className={`mb-1 ${isActive ? "active-module" : ""}`}
                                                >
                                                    <a
                                                        className="dropdown-item d-flex align-items-center gap-2 module-item"
                                                        onClick={() => handleModuleClick(mod)}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <i
                                                            className={`fas fa-${mod.ImageIcon}`}
                                                            style={{
                                                                color: iconColors[index % iconColors.length],
                                                                textShadow: "1px 1px 3px rgba(0,0,0,0.5)",
                                                            }}
                                                        ></i>
                                                        <span>{mod.ModuleName}</span>
                                                    </a>
                                                </li>
                                            );
                                        })}
                                        <li className="dropdown-item d-flex align-items-center gap-2 module-item"
                                            onClick={() => navigate("/user-modules")}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <i
                                                className="fa-solid fa-arrow-left"
                                                style={{
                                                    color: "#ffccbc",
                                                    textShadow: "1px 1px 3px rgba(0,0,0,0.5)",
                                                }}
                                            ></i>
                                            <span>Go Back to Portal</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-items-center py-3 mb-2 d-none d-md-block">
                            <div className="welcome-animation">
                                <h2 className="mb-0">
                                    <span className="text-dark fw-light">Welcome, </span>
                                    <span className="animated-gradient-text">
                                        {sessionUserData?.Name || "Guest"}
                                    </span>
                                    <span className="ms-2">👋</span>
                                </h2>
                                <div
                                    className="mt-1"
                                    style={{
                                        height: '3px',
                                        width: '60px',
                                        background: '#0d6efd',
                                        borderRadius: '10px',
                                        opacity: '0.6'
                                    }}
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="kt_app_content" className="app-content flex-column-fluid" style={{ marginTop: '-30px' }}>
                    <div id="kt_app_content_container" className="app-container container-xxl">
                        <div className="d-flex flex-wrap align-items-center gap-2 mb-3 bg-white shadow-sm p-2 rounded-2">
                            {showOrgTab && (
                                <button
                                    className={`btn rounded-pill px-3 px-md-4 py-2 fw-semibold ${activeTab === "organization"
                                        ? "btn-primary shadow-sm"
                                        : "btn-light border"
                                        }`}
                                    onClick={() => setActiveTab("organization")}
                                >
                                    <i className="fa-solid fa-building me-2"></i>
                                    Organization KPI
                                </button>
                            )}

                            {showDeptTab && (
                                <button
                                    className={`btn rounded-pill px-3 px-md-4 py-2 fw-semibold ${activeTab === "department"
                                        ? "btn-primary shadow-sm"
                                        : "btn-light border"
                                        }`}
                                    onClick={() => setActiveTab("department")}
                                >
                                    <i className="fa-solid fa-users-gear me-2"></i>
                                    Department KPI
                                </button>
                            )}

                            <Link
                                to={`/kpi/allocate-kpi/${selectedMainDept}`}
                                className="btn rounded-pill px-3 px-md-4 py-2 fw-semibold btn-light-primary"
                            >
                                <i className="bi bi-bullseye me-2"></i>
                                Allocate KPI
                            </Link>

                            {showAdd && (
                                <div className="kpi-actions">
                                    <button
                                        className="premium-btn-primary btn-sm"
                                        onClick={() => setOpenCreateKPI(true)}
                                        title={"Create Parent KPI"}
                                    >
                                        <span className="premium-btn-icon">
                                            <i className="bi bi-plus-lg"></i>
                                        </span>
                                        <span>Create KPI</span>
                                    </button>
                                </div>
                            )}
                        </div>

                        {activeTab === "organization" && (
                            <>
                                <div className="card shadow-sm border-0 d-none d-md-block">
                                    <div className="card-body">

                                        {/* Organization KPI Header */}
                                        <div className="card border-0 shadow-sm mb-4">
                                            <div className="card-body py-3">

                                                <div className="organization-kpi-header">

                                                    {/* Title */}
                                                    <div className="organization-kpi-title">
                                                        <h3 className="mb-0">
                                                            Organization KPI Management
                                                        </h3>
                                                    </div>
                                                    <div className="col-12 col-md-3">
                                                        <Select
                                                            style={{ width: "100%" }}
                                                            size="large"
                                                            placeholder="Select Department"
                                                            showSearch
                                                            optionFilterProp="label"
                                                            value={selectedMainDept}
                                                            onChange={(value) => setSelectedMainDept(value)}
                                                            options={departments?.map((dept) => ({
                                                                value: dept.ItemId,
                                                                label: dept.ItemValue,
                                                            }))}
                                                        />
                                                    </div>
                                                    {/* Search */}
                                                    <div className="organization-kpi-search">
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text bg-light border-end-0">
                                                                <i className="fa fa-search text-muted"></i>
                                                            </span>

                                                            <input
                                                                type="text"
                                                                className="form-control border-start-0"
                                                                placeholder="Search KPI Name..."
                                                                value={parentKpiSearch}
                                                                onChange={(e) => {
                                                                    setParentKpiSearch(e.target.value);
                                                                    setParentKpiPage(1);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>

                                        {/* KPI Table */}
                                        <div className="table-responsive organization-kpi-table">

                                            <table className="table align-middle table-hover gs-7 gy-4 mb-0 fs-6">

                                                <thead className="bg-light-primary">
                                                    <tr className="text-start text-muted fw-bold fs-7 text-uppercase border-bottom-2 border-primary">

                                                        <th>#</th>

                                                        <th>KPI Name</th>

                                                        <th>Registered During</th>

                                                        <th>Objective</th>

                                                        <th>UoM</th>

                                                        <th width="80">
                                                            Actions
                                                        </th>

                                                    </tr>
                                                </thead>

                                                <tbody className="fw-semibold text-gray-700">

                                                    {parentKpiRecords.map((item, index) => (

                                                        <tr key={item.Id}>

                                                            <td>
                                                                {index + 1}
                                                            </td>

                                                            <td>
                                                                {item.KPIName}
                                                            </td>

                                                            <td>
                                                                {item.Registered_During || "---"}
                                                            </td>

                                                            <td
                                                                style={{
                                                                    maxWidth: "320px"
                                                                }}
                                                            >
                                                                <Tooltip
                                                                    title={
                                                                        stripHtml(item.Objectives) || "-"
                                                                    }
                                                                    placement="topLeft"
                                                                    overlayStyle={{
                                                                        maxWidth: 350
                                                                    }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            cursor: "pointer"
                                                                        }}
                                                                    >
                                                                        {(() => {

                                                                            const text =
                                                                                stripHtml(
                                                                                    item.Objectives
                                                                                );

                                                                            return text
                                                                                ? text.length > 90
                                                                                    ? `${text.substring(
                                                                                        0,
                                                                                        90
                                                                                    )}...`
                                                                                    : text
                                                                                : "-";

                                                                        })()}
                                                                    </span>
                                                                </Tooltip>
                                                            </td>

                                                            <td>
                                                                {item.UOMName || "---"}
                                                            </td>

                                                            {/* Actions */}
                                                            <td>

                                                                <Dropdown
                                                                    trigger={["hover"]}
                                                                    placement="bottomRight"
                                                                    overlayClassName="premium-dropdown"
                                                                    menu={{
                                                                        items: [

                                                                            {
                                                                                key: "tree",
                                                                                disabled: true,
                                                                                label: (
                                                                                    <Tooltip
                                                                                        title="Coming Soon"
                                                                                        placement="left"
                                                                                    >
                                                                                        <div className="dropdown-item-premium opacity-50">

                                                                                            <i className="bi bi-diagram-3-fill text-secondary"></i>

                                                                                            <span>
                                                                                                Tree View
                                                                                            </span>

                                                                                            <span className="badge bg-warning text-dark ms-auto">
                                                                                                Soon
                                                                                            </span>

                                                                                        </div>
                                                                                    </Tooltip>
                                                                                ),
                                                                            },

                                                                            {
                                                                                key: "edit",
                                                                                label: (
                                                                                    <Tooltip
                                                                                        title={
                                                                                            !showEdit
                                                                                                ? "You don't have access to edit this KPI."
                                                                                                : item.Status ===
                                                                                                    "RELEASED"
                                                                                                    ? "Released KPIs cannot be edited."
                                                                                                    : "Edit KPI"
                                                                                        }
                                                                                    >
                                                                                        <div
                                                                                            className={`dropdown-item-premium ${!showEdit ||
                                                                                                item.Status ===
                                                                                                "RELEASED"
                                                                                                ? "opacity-50"
                                                                                                : ""
                                                                                                }`}
                                                                                            onClick={(e) => {

                                                                                                if (
                                                                                                    !showEdit ||
                                                                                                    item.Status ===
                                                                                                    "RELEASED"
                                                                                                ) {
                                                                                                    e.stopPropagation();
                                                                                                    return;
                                                                                                }

                                                                                                setSelectedKPI(
                                                                                                    item
                                                                                                );

                                                                                                setOpenEditModal(
                                                                                                    true
                                                                                                );

                                                                                            }}
                                                                                        >

                                                                                            <i className="bi bi-pencil-square text-warning"></i>

                                                                                            <span>
                                                                                                Edit KPI
                                                                                            </span>

                                                                                        </div>
                                                                                    </Tooltip>
                                                                                ),
                                                                            },

                                                                            {
                                                                                type: "divider",
                                                                            },

                                                                            {
                                                                                key: "delete",
                                                                                danger: true,
                                                                                disabled: !showDelete,
                                                                                label: (
                                                                                    <Tooltip
                                                                                        title={
                                                                                            !showDelete
                                                                                                ? "You don't have access to delete this KPI."
                                                                                                : ""
                                                                                        }
                                                                                        placement="left"
                                                                                    >
                                                                                        <div className="dropdown-item-premium">

                                                                                            <i className="bi bi-trash3 text-danger"></i>

                                                                                            <span>
                                                                                                Delete KPI
                                                                                            </span>

                                                                                        </div>
                                                                                    </Tooltip>
                                                                                ),

                                                                                onClick: () => {

                                                                                    if (!showDelete)
                                                                                        return;

                                                                                    setDeleteKPI(item);

                                                                                },
                                                                            },

                                                                        ],
                                                                    }}
                                                                >

                                                                    <button
                                                                        type="button"
                                                                        className="action-menu-btn"
                                                                    >
                                                                        <i className="bi bi-three-dots-vertical"></i>
                                                                    </button>

                                                                </Dropdown>

                                                            </td>

                                                        </tr>

                                                    ))}

                                                </tbody>

                                            </table>

                                        </div>

                                        {/* Pagination */}
                                        <div className="organization-pagination d-flex justify-content-between align-items-center flex-wrap pt-10">
                                            <div className="d-flex align-items-center gap-4 flex-wrap">
                                                <div className="fs-6 fw-bold text-gray-700">
                                                    Showing{" "}
                                                    {filteredParentKpis.length > 0
                                                        ? parentKpiFirstIndex + 1
                                                        : 0}
                                                    {" "}to{" "}
                                                    {Math.min(
                                                        parentKpiLastIndex,
                                                        filteredParentKpis.length
                                                    )}
                                                    {" "}of{" "}
                                                    {filteredParentKpis.length}
                                                    {parentKpiSearch &&
                                                        ` (filtered from ${managerKpis.length} total entries)`}
                                                </div>
                                            </div>

                                            <ul className="pagination mb-0">
                                                <li
                                                    className={`page-item previous ${parentKpiPage === 1
                                                        ? "disabled"
                                                        : ""
                                                        }`}
                                                >
                                                    <button
                                                        type="button"
                                                        className="page-link cursor-pointer"
                                                        onClick={() =>
                                                            handleParentKpiPageChange(
                                                                parentKpiPage - 1
                                                            )
                                                        }
                                                    >
                                                        <i className="ki-outline ki-left fs-2"></i>
                                                    </button>
                                                </li>

                                                {getParentKpiPageNumbers().map(
                                                    (pageNum, i) => (
                                                        <li
                                                            key={i}
                                                            className={`page-item ${parentKpiPage === pageNum
                                                                ? "active"
                                                                : ""
                                                                } ${pageNum === "..."
                                                                    ? "disabled"
                                                                    : ""
                                                                }`}
                                                        >
                                                            {pageNum === "..." ? (
                                                                <span className="page-link">
                                                                    ...
                                                                </span>
                                                            ) : (
                                                                <button
                                                                    type="button"
                                                                    className="page-link cursor-pointer"
                                                                    onClick={() =>
                                                                        handleParentKpiPageChange(
                                                                            pageNum
                                                                        )
                                                                    }
                                                                >
                                                                    {pageNum}
                                                                </button>
                                                            )}
                                                        </li>
                                                    )
                                                )}

                                                <li
                                                    className={`page-item next ${parentKpiPage === totalPages
                                                        ? "disabled"
                                                        : ""
                                                        }`}
                                                >
                                                    <button
                                                        type="button"
                                                        className="page-link cursor-pointer"
                                                        onClick={() =>
                                                            handleParentKpiPageChange(
                                                                parentKpiPage + 1
                                                            )
                                                        }
                                                    >
                                                        <i className="ki-outline ki-right fs-2"></i>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-block d-md-none card shadow-sm border-0 mt-5">
                                    <div className="card border-0 shadow-sm mb-4">
                                        <div className="card-body py-3">
                                            <div className="organization-kpi-header">
                                                <div className="organization-kpi-title">
                                                    <h3 className="mb-0">
                                                        Organization KPI Management
                                                    </h3>
                                                </div>
                                                <div className="col-12 col-md-3">
                                                    <Select
                                                        style={{ width: "100%" }}
                                                        size="large"
                                                        placeholder="Select Department"
                                                        showSearch
                                                        optionFilterProp="label"
                                                        value={selectedMainDept}
                                                        onChange={(value) => setSelectedMainDept(value)}
                                                        options={departments?.map((dept) => ({
                                                            value: dept.ItemId,
                                                            label: dept.ItemValue,
                                                        }))}
                                                    />
                                                </div>
                                                <div className="organization-kpi-search">

                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text bg-light border-end-0">
                                                            <i className="fa fa-search text-muted"></i>
                                                        </span>

                                                        <input
                                                            type="text"
                                                            className="form-control border-start-0"
                                                            placeholder="Search KPI Name..."
                                                            value={parentKpiSearch}
                                                            onChange={(e) => {
                                                                setParentKpiSearch(e.target.value);
                                                                setParentKpiPage(1);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row g-3">
                                        {parentKpiRecords.map((item, index) => {

                                            const objectiveText =
                                                stripHtml(item.Objectives);

                                            return (
                                                <div
                                                    className="col-12"
                                                    key={item.Id}
                                                >
                                                    <div className="card border shadow-sm rounded-3 mx-4">
                                                        <div className="card-body p-3">
                                                            <div className="d-flex justify-content-between align-items-start gap-2 mb-3">
                                                                <div className="d-flex align-items-start gap-2">
                                                                    <div
                                                                        className="bg-light-primary rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                                                                        style={{
                                                                            width: "38px",
                                                                            height: "38px"
                                                                        }}
                                                                    >
                                                                        <i className="bi bi-bar-chart-fill text-primary"></i>
                                                                    </div>
                                                                    <div>
                                                                        <div className="text-muted fs-8 mb-1">
                                                                            KPI #{index + 1}
                                                                        </div>
                                                                        <div className="fw-bold text-gray-800 fs-6">
                                                                            {item.KPIName || "---"}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <Dropdown
                                                                    trigger={["click"]}
                                                                    placement="bottomRight"
                                                                    overlayClassName="premium-dropdown"
                                                                    menu={{
                                                                        items: [

                                                                            {
                                                                                key: "tree",
                                                                                disabled: true,
                                                                                label: (
                                                                                    <div className="dropdown-item-premium opacity-50">
                                                                                        <i className="bi bi-diagram-3-fill text-secondary"></i>
                                                                                        <span>
                                                                                            Tree View
                                                                                        </span>
                                                                                        <span className="badge bg-warning text-dark ms-auto">
                                                                                            Soon
                                                                                        </span>
                                                                                    </div>
                                                                                ),
                                                                            },

                                                                            {
                                                                                key: "edit",
                                                                                label: (
                                                                                    <div
                                                                                        className={`dropdown-item-premium ${!showEdit ||
                                                                                            item.Status ===
                                                                                            "RELEASED"
                                                                                            ? "opacity-50"
                                                                                            : ""
                                                                                            }`}
                                                                                        onClick={(e) => {

                                                                                            if (
                                                                                                !showEdit ||
                                                                                                item.Status ===
                                                                                                "RELEASED"
                                                                                            ) {
                                                                                                e.stopPropagation();
                                                                                                return;
                                                                                            }

                                                                                            setSelectedKPI(item);
                                                                                            setOpenEditModal(true);

                                                                                        }}
                                                                                    >
                                                                                        <i className="bi bi-pencil-square text-warning"></i>
                                                                                        <span>
                                                                                            Edit KPI
                                                                                        </span>
                                                                                    </div>
                                                                                ),
                                                                            },

                                                                            {
                                                                                type: "divider",
                                                                            },

                                                                            {
                                                                                key: "delete",
                                                                                danger: true,
                                                                                disabled: !showDelete,
                                                                                label: (
                                                                                    <div className="dropdown-item-premium">
                                                                                        <i className="bi bi-trash3 text-danger"></i>
                                                                                        <span>
                                                                                            Delete KPI
                                                                                        </span>
                                                                                    </div>
                                                                                ),

                                                                                onClick: () => {
                                                                                    if (!showDelete)
                                                                                        return;
                                                                                    setDeleteKPI(item);
                                                                                },
                                                                            },

                                                                        ],
                                                                    }}
                                                                >
                                                                    <button
                                                                        type="button"
                                                                        className="action-menu-btn"
                                                                    >
                                                                        <i className="bi bi-three-dots-vertical"></i>
                                                                    </button>
                                                                </Dropdown>
                                                            </div>

                                                            {/* KPI Details */}
                                                            <div className="border-top pt-3">
                                                                <div className="row g-3">
                                                                    <div className="col-6">
                                                                        <div className="text-muted fs-8 mb-1">
                                                                            Registered During
                                                                        </div>
                                                                        <div className="fw-semibold text-gray-700 fs-7">
                                                                            {item.Registered_During || "---"}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <div className="text-muted fs-8 mb-1">
                                                                            Unit of Measure
                                                                        </div>
                                                                        <div className="fw-semibold text-gray-700 fs-7">
                                                                            {item.UOMName || "---"}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-12">
                                                                        <div className="text-muted fs-8 mb-1">
                                                                            Objective
                                                                        </div>
                                                                        <div className="fw-normal text-gray-700 fs-7">
                                                                            {objectiveText
                                                                                ? objectiveText.length > 150
                                                                                    ? `${objectiveText.substring(
                                                                                        0,
                                                                                        150
                                                                                    )}...`
                                                                                    : objectiveText
                                                                                : "---"}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </>
                        )}

                        {activeTab === "department" && (
                            <>
                                <div className="card shadow-sm border-0 department-kpi-card d-none d-md-block">
                                    <div className="card-body">

                                        <div className="card border-0 shadow-sm mb-4 department-kpi-header-card">
                                            <div className="card-body py-3">
                                                <div className="department-kpi-header">
                                                    <div className="department-kpi-title">
                                                        <h6 className="fw-bold mb-1 text-dark">
                                                            {kpiView === "department"
                                                                ? "Department KPI Management"
                                                                : "Individual KPIs"}
                                                        </h6>

                                                        <small className="text-muted">
                                                            {kpiView === "department"
                                                                ? "Manage department-level KPIs."
                                                                : "View and manage your individual KPIs."}
                                                        </small>
                                                    </div>
                                                    <div className="col-12 col-md-3">
                                                        <Select
                                                            style={{ width: "100%" }}
                                                            size="large"
                                                            placeholder="Select Department"
                                                            showSearch
                                                            optionFilterProp="label"
                                                            value={selectedMainDept}
                                                            onChange={(value) => setSelectedMainDept(value)}
                                                            options={departments?.map((dept) => ({
                                                                value: dept.ItemId,
                                                                label: dept.ItemValue,
                                                            }))}
                                                        />
                                                    </div>
                                                    <div className="d-flex align-items-center gap-3 flex-wrap">
                                                        {/* KPI View Toggle */}
                                                        <div className="kpi-view-toggle">
                                                            <button
                                                                type="button"
                                                                className={`kpi-toggle-btn ${kpiView === "department" ? "active" : ""
                                                                    }`}
                                                                onClick={() => setKpiView("department")}
                                                            >
                                                                <i className="bi bi-building me-2"></i>
                                                                Department KPIs
                                                            </button>

                                                            <button
                                                                type="button"
                                                                className={`kpi-toggle-btn ${kpiView === "my" ? "active" : ""
                                                                    }`}
                                                                onClick={() => setKpiView("my")}
                                                            >
                                                                <i className="bi bi-person-check me-2"></i>
                                                                Individual KPIs
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {!openChildTab && (
                                            <div className="department-kpi-table-wrapper">
                                                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-3">

                                                    {/* Left Side - Entries */}
                                                    <div className="department-kpi-entries d-flex align-items-center gap-2 bg-light p-2 rounded">

                                                        <span className="text-muted fw-bold">
                                                            Show
                                                        </span>

                                                        <Select
                                                            style={{ width: 80 }}
                                                            size="small"
                                                            value={recordsPerPage}
                                                            onChange={(value) => {
                                                                setRecordsPerPage(value);
                                                                setCurrentPage(1);
                                                            }}
                                                            options={[
                                                                {
                                                                    value: 10,
                                                                    label: "10",
                                                                },
                                                                {
                                                                    value: 50,
                                                                    label: "50",
                                                                },
                                                                {
                                                                    value: 100,
                                                                    label: "100",
                                                                },
                                                            ]}
                                                        />

                                                        <span className="text-muted fw-bold">
                                                            entries
                                                        </span>

                                                    </div>


                                                    {/* Right Side - Search */}
                                                    <div className="department-kpi-search me-2">

                                                        <div className="input-group">

                                                            <span
                                                                className="input-group-text bg-light border-end-0"
                                                                style={{
                                                                    borderRadius: "10px 0 0 10px",
                                                                }}
                                                            >
                                                                <i className="fa fa-search text-muted"></i>
                                                            </span>

                                                            <input
                                                                type="text"
                                                                className="form-control border-start-0 border-end-0"
                                                                placeholder="Search KPI by name or objective..."
                                                                value={searchQuery}
                                                                onChange={(e) =>
                                                                    setSearchQuery(e.target.value)
                                                                }
                                                                style={{
                                                                    boxShadow: "none",
                                                                }}
                                                            />

                                                            {searchQuery && (
                                                                <span
                                                                    className="input-group-text bg-white border-start-0"
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        borderRadius: "0 10px 10px 0",
                                                                    }}
                                                                    onClick={() =>
                                                                        setSearchQuery("")
                                                                    }
                                                                >
                                                                    <i className="bi bi-x-circle-fill text-muted"></i>
                                                                </span>
                                                            )}

                                                        </div>

                                                    </div>

                                                </div>


                                                <div className="department-parent-table-scroll">

                                                    <table
                                                        className="table align-middle table-hover gs-7 gy-4 mb-0 fs-6 parent-kpi-table"
                                                        style={{
                                                            tableLayout: "fixed",
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <thead className="bg-light">
                                                            <tr className="text-start text-muted fw-bold fs-7 text-uppercase">
                                                                <th
                                                                    width="40"
                                                                    className="border-0"
                                                                ></th>

                                                                <th
                                                                    width="60"
                                                                    className="border-0"
                                                                >
                                                                    #
                                                                </th>

                                                                <th className="border-0">
                                                                    KPI Name
                                                                </th>

                                                                <th
                                                                    className="border-0"
                                                                    width="170"
                                                                >
                                                                    Registered During
                                                                </th>

                                                                <th
                                                                    className="border-0"
                                                                    width="200"
                                                                >
                                                                    Measurables
                                                                </th>

                                                                <th className="border-0">
                                                                    Objective
                                                                </th>

                                                                <th
                                                                    className="border-0"
                                                                    width="140"
                                                                >
                                                                    UOM
                                                                </th>

                                                                <th
                                                                    width="90"
                                                                    className="border-0 text-center"
                                                                >
                                                                    Actions
                                                                </th>
                                                            </tr>
                                                        </thead>


                                                        <tbody className="fw-semibold text-gray-700">
                                                            {currentRecords?.length > 0 ? (
                                                                currentRecords.map((item, index) => {
                                                                    const isExpanded =
                                                                        expandedRows.has(
                                                                            item.ParentId
                                                                        );

                                                                    const children =
                                                                        childKpisMap[
                                                                        item.ParentId
                                                                        ] || [];

                                                                    const accent =
                                                                        [
                                                                            "accent-primary",
                                                                            "accent-success",
                                                                            "accent-info",
                                                                        ][index % 3];

                                                                    return (
                                                                        <React.Fragment
                                                                            key={item.Id}
                                                                        >
                                                                            <tr
                                                                                style={{
                                                                                    cursor: "pointer",
                                                                                }}
                                                                                className={`kpi-row ${accent} ${isExpanded
                                                                                    ? "bg-light"
                                                                                    : ""
                                                                                    }`}
                                                                                onClick={() =>
                                                                                    toggleRow(
                                                                                        item.ParentId
                                                                                    )
                                                                                }
                                                                            >
                                                                                <td className="text-center border-0">
                                                                                    <span className="chevron-btn d-inline-flex align-items-center justify-content-center rounded-3 bg-light-primary">
                                                                                        <i
                                                                                            className={`bi ${isExpanded
                                                                                                ? "bi-chevron-down"
                                                                                                : "bi-chevron-right"
                                                                                                } text-primary`}
                                                                                        ></i>
                                                                                    </span>
                                                                                </td>

                                                                                <td className="border-0">
                                                                                    <span className="avatar-square d-inline-flex align-items-center justify-content-center rounded-3 bg-primary text-white fw-bold">
                                                                                        {index + 1}
                                                                                    </span>
                                                                                </td>

                                                                                <td className="border-0">
                                                                                    <div className="d-flex align-items-center gap-2">
                                                                                        <span className="avatar-circle d-inline-flex align-items-center justify-content-center rounded-circle bg-light-primary">
                                                                                            <i className="bi bi-bullseye text-primary"></i>
                                                                                        </span>
                                                                                        <div>
                                                                                            <div className="fw-bold text-gray-800">
                                                                                                {
                                                                                                    item.KPIName
                                                                                                }
                                                                                            </div>

                                                                                            {children.length >
                                                                                                0 && (
                                                                                                    <span className="badge badge-light-secondary rounded-pill fw-normal">
                                                                                                        {
                                                                                                            children.length
                                                                                                        }{" "}
                                                                                                        Child KPI
                                                                                                        {children.length >
                                                                                                            1
                                                                                                            ? "s"
                                                                                                            : ""}
                                                                                                    </span>
                                                                                                )}
                                                                                        </div>
                                                                                    </div>
                                                                                </td>

                                                                                <td className="border-0">
                                                                                    <i className="bi bi-calendar3 text-muted me-1"></i>
                                                                                    {item.Registered_During ||
                                                                                        "---"}
                                                                                </td>

                                                                                <td className="border-0">
                                                                                    {item.Measurables ? (
                                                                                        <Tooltip title={item.Measurables} placement="top">
                                                                                            <span style={{ cursor: "pointer" }}>
                                                                                                {item.Measurables.length > 25
                                                                                                    ? `${item.Measurables.slice(0, 25)}...`
                                                                                                    : item.Measurables}
                                                                                            </span>
                                                                                        </Tooltip>
                                                                                    ) : (
                                                                                        "---"
                                                                                    )}
                                                                                </td>

                                                                                <td
                                                                                    className="border-0"
                                                                                    style={{
                                                                                        maxWidth: "320px",
                                                                                    }}
                                                                                >

                                                                                    <Tooltip
                                                                                        title={
                                                                                            stripHtml(
                                                                                                item.Objectives
                                                                                            ) || "-"
                                                                                        }
                                                                                        placement="topLeft"
                                                                                        overlayStyle={{
                                                                                            maxWidth: 350,
                                                                                        }}
                                                                                    >
                                                                                        <span
                                                                                            style={{
                                                                                                cursor: "pointer",
                                                                                            }}
                                                                                        >
                                                                                            {(() => {

                                                                                                const text =
                                                                                                    stripHtml(
                                                                                                        item.Objectives
                                                                                                    );

                                                                                                return text
                                                                                                    ? text.length >
                                                                                                        90
                                                                                                        ? `${text.substring(
                                                                                                            0,
                                                                                                            90
                                                                                                        )}...`
                                                                                                        : text
                                                                                                    : "-";
                                                                                            })()}
                                                                                        </span>
                                                                                    </Tooltip>
                                                                                </td>

                                                                                <td className="border-0">
                                                                                    <span className="badge badge-light-info rounded-pill">
                                                                                        {item.UOMName ||
                                                                                            "---"}
                                                                                    </span>
                                                                                </td>
                                                                                <td
                                                                                    className="border-0 text-center"
                                                                                    onClick={(e) =>
                                                                                        e.stopPropagation()
                                                                                    }
                                                                                >
                                                                                    <Dropdown
                                                                                        trigger={["hover"]}
                                                                                        placement="bottomRight"
                                                                                        overlayClassName="premium-dropdown"
                                                                                        menu={{
                                                                                            items: [
                                                                                                {
                                                                                                    key: "addKpi",

                                                                                                    label: (
                                                                                                        <div
                                                                                                            className="dropdown-item-premium"
                                                                                                            onClick={() => {
                                                                                                                if (
                                                                                                                    !showAdd
                                                                                                                )
                                                                                                                    return;

                                                                                                                setOpenCreateKPI(
                                                                                                                    true
                                                                                                                );

                                                                                                                setSelectedParentKPIId(
                                                                                                                    item.ParentId
                                                                                                                );

                                                                                                                setSelectedParentUOMId(
                                                                                                                    item.UOMId
                                                                                                                );

                                                                                                            }}
                                                                                                        >
                                                                                                            <i className="bi bi-node-plus-fill text-success"></i>
                                                                                                            <span>
                                                                                                                Create
                                                                                                                Child
                                                                                                                KPI
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    ),
                                                                                                },
                                                                                            ],
                                                                                        }}
                                                                                    >
                                                                                        <button
                                                                                            type="button"
                                                                                            className="action-menu-btn"
                                                                                        >
                                                                                            <i className="bi bi-three-dots-vertical"></i>
                                                                                        </button>
                                                                                    </Dropdown>
                                                                                </td>
                                                                            </tr>


                                                                            {/* ==========================================
                                                        CHILD KPI
                                                    ========================================== */}

                                                                            {isExpanded && (
                                                                                <tr>
                                                                                    <td
                                                                                        colSpan="8"
                                                                                        className="p-0 border-0"
                                                                                    >
                                                                                        <div className="child-kpi-wrapper">
                                                                                            <div className="child-header">
                                                                                                <i className="bi bi-diagram-3-fill me-2 text-primary"></i>
                                                                                                Child KPIs of
                                                                                                <span className="ms-1 text-primary">
                                                                                                    "{item.KPIName}"
                                                                                                </span>
                                                                                                <span className="badge bg-light-primary text-primary ms-3 rounded-pill">
                                                                                                    {children.length}
                                                                                                </span>
                                                                                            </div>

                                                                                            <div className="child-kpi-table-scroll">
                                                                                                <table className="table align-middle table-hover gs-7 gy-4 mb-0 fs-6 child-kpi-table">
                                                                                                    <thead className="bg-light">
                                                                                                        <tr className="text-start text-muted fw-bold fs-7 text-uppercase">
                                                                                                            <th className="child-col-sno">
                                                                                                                #
                                                                                                            </th>
                                                                                                            <th className="child-col-name">
                                                                                                                KPI Name
                                                                                                            </th>
                                                                                                            <th className="child-col-registered">
                                                                                                                Registered During
                                                                                                            </th>
                                                                                                            <th className="child-col-measurables">
                                                                                                                Measurables
                                                                                                            </th>
                                                                                                            <th className="child-col-objective">
                                                                                                                Objective
                                                                                                            </th>
                                                                                                            <th className="child-col-actions text-center">
                                                                                                                Actions
                                                                                                            </th>
                                                                                                        </tr>
                                                                                                    </thead>

                                                                                                    <tbody>

                                                                                                        {children.map((child, index) => (
                                                                                                            <tr key={child.Id}>

                                                                                                                <td className="child-col-sno">
                                                                                                                    {index + 1}
                                                                                                                </td>

                                                                                                                <td className="child-col-name">
                                                                                                                    <div className="fw-bold">
                                                                                                                        {child.KPIName}
                                                                                                                    </div>
                                                                                                                    <div className="text-muted small">
                                                                                                                        Child KPI
                                                                                                                    </div>
                                                                                                                </td>

                                                                                                                <td className="child-col-registered">
                                                                                                                    <span className="badge bg-light-info text-info rounded-pill">
                                                                                                                        {child.Registered_During || "---"}
                                                                                                                    </span>
                                                                                                                </td>

                                                                                                                <td className="child-col-measurables">
                                                                                                                    <span className="badge bg-light-info text-info rounded-pill">
                                                                                                                        {child.Measurables || "---"}
                                                                                                                    </span>
                                                                                                                </td>

                                                                                                                <td className="child-col-objective">

                                                                                                                    {(() => {

                                                                                                                        const tempDiv =
                                                                                                                            document.createElement("div");

                                                                                                                        tempDiv.innerHTML =
                                                                                                                            child.Objectives || "";

                                                                                                                        const plainText =
                                                                                                                            tempDiv.textContent ||
                                                                                                                            tempDiv.innerText ||
                                                                                                                            "";

                                                                                                                        return (
                                                                                                                            <Tooltip
                                                                                                                                title={
                                                                                                                                    <div
                                                                                                                                        className="quill-tooltip-content"
                                                                                                                                        dangerouslySetInnerHTML={{
                                                                                                                                            __html:
                                                                                                                                                child.Objectives ||
                                                                                                                                                "",
                                                                                                                                        }}
                                                                                                                                    />
                                                                                                                                }
                                                                                                                            >
                                                                                                                                <span>
                                                                                                                                    {plainText.length > 60
                                                                                                                                        ? `${plainText.substring(
                                                                                                                                            0,
                                                                                                                                            60
                                                                                                                                        )}...`
                                                                                                                                        : plainText || "---"}
                                                                                                                                </span>
                                                                                                                            </Tooltip>
                                                                                                                        );
                                                                                                                    })()}
                                                                                                                </td>

                                                                                                                <td className="child-col-actions text-center">
                                                                                                                    <Dropdown
                                                                                                                        trigger={["hover"]}
                                                                                                                        placement="bottomRight"
                                                                                                                        overlayClassName="premium-dropdown"
                                                                                                                        menu={{
                                                                                                                            items: [
                                                                                                                                {
                                                                                                                                    key: "edit",
                                                                                                                                    label: (
                                                                                                                                        <Tooltip
                                                                                                                                            title={
                                                                                                                                                !showEdit
                                                                                                                                                    ? "You don't have access to edit this KPI."
                                                                                                                                                    : child.Status ===
                                                                                                                                                        "RELEASED"
                                                                                                                                                        ? "Released KPIs cannot be edited."
                                                                                                                                                        : "Edit KPI"
                                                                                                                                            }
                                                                                                                                        >
                                                                                                                                            <div
                                                                                                                                                className={`dropdown-item-premium ${!showEdit ||
                                                                                                                                                    child.Status ===
                                                                                                                                                    "RELEASED"
                                                                                                                                                    ? "opacity-50"
                                                                                                                                                    : ""
                                                                                                                                                    }`}
                                                                                                                                                onClick={(e) => {
                                                                                                                                                    if (
                                                                                                                                                        !showEdit ||
                                                                                                                                                        child.Status ===
                                                                                                                                                        "RELEASED"
                                                                                                                                                    ) {
                                                                                                                                                        e.stopPropagation();
                                                                                                                                                        return;
                                                                                                                                                    }

                                                                                                                                                    setSelectedKPI(
                                                                                                                                                        child
                                                                                                                                                    );

                                                                                                                                                    setOpenEditModal(
                                                                                                                                                        true
                                                                                                                                                    );
                                                                                                                                                }}
                                                                                                                                            >
                                                                                                                                                <i className="bi bi-pencil-square text-warning"></i>
                                                                                                                                                <span>
                                                                                                                                                    Edit KPI
                                                                                                                                                </span>
                                                                                                                                            </div>
                                                                                                                                        </Tooltip>
                                                                                                                                    ),
                                                                                                                                },

                                                                                                                                {
                                                                                                                                    type: "divider",
                                                                                                                                },

                                                                                                                                {
                                                                                                                                    key: "delete",
                                                                                                                                    danger: true,
                                                                                                                                    disabled:
                                                                                                                                        !showDelete,
                                                                                                                                    label: (
                                                                                                                                        <div className="dropdown-item-premium">
                                                                                                                                            <i className="bi bi-trash3 text-danger"></i>
                                                                                                                                            <span>
                                                                                                                                                Delete KPI
                                                                                                                                            </span>
                                                                                                                                        </div>
                                                                                                                                    ),
                                                                                                                                    onClick: () => {
                                                                                                                                        if (!showDelete)
                                                                                                                                            return;
                                                                                                                                        setDeleteKPI(
                                                                                                                                            child
                                                                                                                                        );
                                                                                                                                    },
                                                                                                                                },
                                                                                                                            ],
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <button
                                                                                                                            type="button"
                                                                                                                            className="action-menu-btn"
                                                                                                                        >
                                                                                                                            <i className="bi bi-three-dots-vertical"></i>
                                                                                                                        </button>
                                                                                                                    </Dropdown>
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        ))}
                                                                                                    </tbody>
                                                                                                </table>
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                        </React.Fragment>
                                                                    );
                                                                })
                                                            ) : (
                                                                <tr>
                                                                    <td
                                                                        colSpan="8"
                                                                        className="text-center py-5 text-muted"
                                                                    >
                                                                        No Department KPIs Found
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <div className="department-pagination d-flex justify-content-between align-items-center flex-wrap pt-10">
                                                    <div className="d-flex align-items-center gap-4 flex-wrap">
                                                        <div className="fs-6 fw-bold text-gray-700">
                                                            Showing{" "}
                                                            {filteredKpis.length > 0
                                                                ? indexOfFirstRecord + 1
                                                                : 0}

                                                            {" "}to{" "}
                                                            {Math.min(
                                                                indexOfLastRecord,
                                                                filteredKpis.length
                                                            )}
                                                            {" "}of{" "}
                                                            {filteredKpis.length}
                                                            {searchQuery &&
                                                                ` (filtered from ${managerKpis?.length
                                                                } total entries)`}
                                                        </div>
                                                    </div>

                                                    <ul className="pagination mb-0">
                                                        <li
                                                            className={`page-item previous ${currentPage === 1
                                                                ? "disabled"
                                                                : ""
                                                                }`}
                                                        >
                                                            <button
                                                                type="button"
                                                                className="page-link cursor-pointer"
                                                                onClick={() =>
                                                                    handlePageChange(
                                                                        currentPage - 1
                                                                    )
                                                                }
                                                            >
                                                                <i className="ki-outline ki-left fs-2"></i>
                                                            </button>
                                                        </li>
                                                        {getPageNumbers().map(
                                                            (pageNum, i) => (
                                                                <li
                                                                    key={i}
                                                                    className={`page-item ${currentPage ===
                                                                        pageNum
                                                                        ? "active"
                                                                        : ""
                                                                        } ${pageNum === "..."
                                                                            ? "disabled"
                                                                            : ""
                                                                        }`}
                                                                >
                                                                    {pageNum === "..." ? (
                                                                        <span className="page-link">
                                                                            ...
                                                                        </span>
                                                                    ) : (

                                                                        <button
                                                                            type="button"
                                                                            className="page-link cursor-pointer"
                                                                            onClick={() =>
                                                                                handlePageChange(
                                                                                    pageNum
                                                                                )
                                                                            }
                                                                        >
                                                                            {pageNum}
                                                                        </button>
                                                                    )}
                                                                </li>
                                                            )
                                                        )}
                                                        <li
                                                            className={`page-item next ${currentPage === totalPages
                                                                ? "disabled"
                                                                : ""
                                                                }`}
                                                        >
                                                            <button
                                                                type="button"
                                                                className="page-link cursor-pointer"
                                                                onClick={() =>
                                                                    handlePageChange(
                                                                        currentPage + 1
                                                                    )
                                                                }
                                                            >
                                                                <i className="ki-outline ki-right fs-2"></i>
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </div>

                                <div className="d-block d-md-none mt-5">
                                    <div className="card border-0 shadow-sm mb-4 department-kpi-header-card">
                                        <div className="card-body py-3">
                                            <div className="department-kpi-header">
                                                <div className="department-kpi-title">
                                                    <h6 className="fw-bold mb-1 text-dark">
                                                        {openChildTab
                                                            ? "Child KPI Management"
                                                            : "Department KPI Management"}
                                                    </h6>
                                                    <small className="text-muted">
                                                        {openChildTab
                                                            ? "Manage child KPIs assigned to the selected parent KPI."
                                                            : "Manage department-level KPIs."}
                                                    </small>

                                                    {openChildTab && (
                                                        <nav className="mt-2">
                                                            <span
                                                                className="text-primary fw-semibold department-breadcrumb"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() =>
                                                                    setOpenChildTab(false)
                                                                }
                                                            >
                                                                Parent KPIs
                                                            </span>

                                                            <i className="bi bi-chevron-right mx-2 text-muted"></i>

                                                            <span className="text-dark fw-bold">
                                                                Child KPIs
                                                            </span>

                                                        </nav>
                                                    )}
                                                </div>

                                                <div className="department-kpi-search">
                                                    <div className="input-group">
                                                        <span
                                                            className="input-group-text bg-light border-end-0"
                                                            style={{
                                                                borderRadius: "10px 0 0 10px",
                                                            }}
                                                        >
                                                            <i className="fa fa-search text-muted"></i>
                                                        </span>
                                                        <input
                                                            type="text"
                                                            className="form-control border-start-0 border-end-0"
                                                            placeholder="Search KPI by name or objective..."
                                                            value={searchQuery}
                                                            onChange={(e) =>
                                                                setSearchQuery(e.target.value)
                                                            }
                                                            style={{
                                                                boxShadow: "none",
                                                            }}
                                                        />
                                                        {searchQuery && (
                                                            <span
                                                                className="input-group-text bg-white border-start-0"
                                                                style={{
                                                                    cursor: "pointer",
                                                                    borderRadius: "0 10px 10px 0",
                                                                }}
                                                                onClick={() =>
                                                                    setSearchQuery("")
                                                                }
                                                            >
                                                                <i className="bi bi-x-circle-fill text-muted"></i>
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="department-mobile-kpi">
                                        {!openChildTab && (
                                            <>
                                                {currentRecords?.length > 0 ? (
                                                    currentRecords.map((item, index) => {
                                                        const isExpanded =
                                                            expandedRows.has(item.ParentId);

                                                        const children =
                                                            childKpisMap[item.ParentId] || [];

                                                        const objectiveText =
                                                            stripHtml(item.Objectives);

                                                        const accent =
                                                            [
                                                                "border-primary",
                                                                "border-success",
                                                                "border-info",
                                                            ][index % 3];

                                                        return (
                                                            <div
                                                                key={item.Id}
                                                                className={`card border-start border-3 ${accent} shadow-sm mb-3`}
                                                            >
                                                                <div
                                                                    className={`card-body p-3 ${isExpanded
                                                                        ? "pb-2"
                                                                        : ""
                                                                        }`}
                                                                    style={{
                                                                        cursor: "pointer",
                                                                    }}
                                                                    onClick={() =>
                                                                        toggleRow(item.ParentId)
                                                                    }
                                                                >
                                                                    <div className="d-flex align-items-start">
                                                                        <div
                                                                            className="d-flex align-items-center justify-content-center rounded-3 bg-primary text-white fw-bold flex-shrink-0 me-2"
                                                                            style={{
                                                                                width: "34px",
                                                                                height: "34px",
                                                                                fontSize: "13px",
                                                                            }}
                                                                        >
                                                                            {index + 1}
                                                                        </div>

                                                                        <div className="flex-grow-1 min-w-0">
                                                                            <div className="fw-bold text-gray-800 fs-6 lh-sm">
                                                                                {item.KPIName || "---"}
                                                                            </div>
                                                                            {children.length > 0 && (
                                                                                <div className="mt-1">
                                                                                    <span className="badge badge-light-secondary rounded-pill fw-normal">
                                                                                        {children.length}{" "}
                                                                                        Child KPI
                                                                                        {children.length > 1
                                                                                            ? "s"
                                                                                            : ""}
                                                                                    </span>
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                        <div
                                                                            className="d-flex align-items-center justify-content-center rounded-3 bg-light-primary flex-shrink-0 ms-2"
                                                                            style={{
                                                                                width: "32px",
                                                                                height: "32px",
                                                                            }}
                                                                        >
                                                                            <i
                                                                                className={`bi ${isExpanded
                                                                                    ? "bi-chevron-down"
                                                                                    : "bi-chevron-right"
                                                                                    } text-primary`}
                                                                            ></i>
                                                                        </div>
                                                                    </div>

                                                                    <div className="border-top mt-3 pt-3">
                                                                        <div className="row g-3">
                                                                            <div className="col-6">
                                                                                <div className="text-muted small mb-1">
                                                                                    Registered During
                                                                                </div>
                                                                                <div className="fw-semibold text-gray-700 fs-7 d-flex align-items-center">
                                                                                    <i className="bi bi-calendar3 text-muted me-1"></i>
                                                                                    <span>
                                                                                        {item.Registered_During ||
                                                                                            "---"}
                                                                                    </span>
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-6">
                                                                                <div className="text-muted small mb-1">
                                                                                    Measurables
                                                                                </div>
                                                                                <div className="fw-semibold text-gray-700 fs-7">
                                                                                    {item.Measurables ||
                                                                                        "---"}
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-6">
                                                                                <div className="text-muted small mb-1">
                                                                                    UOM
                                                                                </div>
                                                                                <span className="badge badge-light-info rounded-pill">
                                                                                    {item.UOMName ||
                                                                                        "---"}
                                                                                </span>
                                                                            </div>

                                                                            <div className="col-6 d-flex justify-content-end align-items-end">
                                                                                <div
                                                                                    onClick={(e) =>
                                                                                        e.stopPropagation()
                                                                                    }
                                                                                >
                                                                                    <Dropdown
                                                                                        trigger={["click"]}
                                                                                        placement="bottomRight"
                                                                                        overlayClassName="premium-dropdown"
                                                                                        menu={{
                                                                                            items: [
                                                                                                {
                                                                                                    key: "addKpi",
                                                                                                    label: (
                                                                                                        <div
                                                                                                            className="dropdown-item-premium"
                                                                                                            onClick={() => {

                                                                                                                if (
                                                                                                                    !showAdd
                                                                                                                )
                                                                                                                    return;

                                                                                                                setOpenCreateKPI(
                                                                                                                    true
                                                                                                                );

                                                                                                                setSelectedParentKPIId(
                                                                                                                    item.ParentId
                                                                                                                );

                                                                                                                setSelectedParentUOMId(
                                                                                                                    item.UOMId
                                                                                                                );

                                                                                                            }}
                                                                                                        >
                                                                                                            <i className="bi bi-node-plus-fill text-success"></i>
                                                                                                            <span>
                                                                                                                Create Child KPI
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    ),
                                                                                                },
                                                                                            ],
                                                                                        }}
                                                                                    >
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm btn-light-primary"
                                                                                            style={{
                                                                                                width: "34px",
                                                                                                height: "34px",
                                                                                                padding: 0,
                                                                                            }}
                                                                                        >
                                                                                            <i className="bi bi-three-dots-vertical"></i>
                                                                                        </button>
                                                                                    </Dropdown>
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-12">
                                                                                <div className="text-muted small mb-1">
                                                                                    Objective
                                                                                </div>
                                                                                <div
                                                                                    className="text-gray-700 fs-7"
                                                                                    style={{
                                                                                        lineHeight: "1.5",
                                                                                    }}
                                                                                >
                                                                                    <Tooltip
                                                                                        title={
                                                                                            objectiveText ||
                                                                                            "-"
                                                                                        }
                                                                                        placement="top"
                                                                                    >
                                                                                        <span>
                                                                                            {objectiveText
                                                                                                ? objectiveText.length >
                                                                                                    150
                                                                                                    ? `${objectiveText.substring(
                                                                                                        0,
                                                                                                        150
                                                                                                    )}...`
                                                                                                    : objectiveText
                                                                                                : "---"}
                                                                                        </span>
                                                                                    </Tooltip>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {isExpanded && (
                                                                    <div className="px-3 pb-3">
                                                                        <div className="bg-light-primary rounded-3 p-3">
                                                                            <div className="d-flex align-items-center mb-3">
                                                                                <i className="bi bi-diagram-3-fill text-primary me-2"></i>
                                                                                <div className="fw-bold text-gray-800 fs-7">
                                                                                    Child KPIs
                                                                                </div>
                                                                                <span className="badge bg-primary text-white rounded-pill ms-2">
                                                                                    {children.length}
                                                                                </span>
                                                                            </div>

                                                                            {/* Child Cards */}
                                                                            {children.length > 0 ? (

                                                                                children.map(
                                                                                    (child, childIndex) => {

                                                                                        const childObjective =
                                                                                            stripHtml(
                                                                                                child.Objectives
                                                                                            );

                                                                                        return (
                                                                                            <div
                                                                                                key={child.Id}
                                                                                                className="card border shadow-none mb-2"
                                                                                            >
                                                                                                <div className="card-body p-3">
                                                                                                    <div className="d-flex align-items-start">
                                                                                                        <div
                                                                                                            className="rounded-2 bg-light-info text-info d-flex align-items-center justify-content-center flex-shrink-0 me-2"
                                                                                                            style={{
                                                                                                                width: "30px",
                                                                                                                height: "30px",
                                                                                                                fontSize: "12px",
                                                                                                                fontWeight: 600,
                                                                                                            }}
                                                                                                        >
                                                                                                            {childIndex +
                                                                                                                1}
                                                                                                        </div>

                                                                                                        <div className="flex-grow-1 min-w-0">
                                                                                                            <div className="fw-bold text-gray-800 fs-7 lh-sm">
                                                                                                                {child.KPIName ||
                                                                                                                    "---"}
                                                                                                            </div>
                                                                                                            <div className="text-muted small mt-1">
                                                                                                                Child KPI
                                                                                                            </div>
                                                                                                        </div>

                                                                                                        <div
                                                                                                            onClick={(
                                                                                                                e
                                                                                                            ) =>
                                                                                                                e.stopPropagation()
                                                                                                            }
                                                                                                        >
                                                                                                            <Dropdown
                                                                                                                trigger={[
                                                                                                                    "click",
                                                                                                                ]}
                                                                                                                placement="bottomRight"
                                                                                                                overlayClassName="premium-dropdown"
                                                                                                                menu={{
                                                                                                                    items: [
                                                                                                                        {
                                                                                                                            key: "edit",
                                                                                                                            label: (
                                                                                                                                <Tooltip
                                                                                                                                    title={
                                                                                                                                        !showEdit
                                                                                                                                            ? "You don't have access to edit this KPI."
                                                                                                                                            : child.Status ===
                                                                                                                                                "RELEASED"
                                                                                                                                                ? "Released KPIs cannot be edited."
                                                                                                                                                : "Edit KPI"
                                                                                                                                    }
                                                                                                                                >
                                                                                                                                    <div
                                                                                                                                        className={`dropdown-item-premium ${!showEdit ||
                                                                                                                                            child.Status ===
                                                                                                                                            "RELEASED"
                                                                                                                                            ? "opacity-50"
                                                                                                                                            : ""
                                                                                                                                            }`}
                                                                                                                                        onClick={(
                                                                                                                                            e
                                                                                                                                        ) => {
                                                                                                                                            if (
                                                                                                                                                !showEdit ||
                                                                                                                                                child.Status ===
                                                                                                                                                "RELEASED"
                                                                                                                                            ) {
                                                                                                                                                e.stopPropagation();
                                                                                                                                                return;
                                                                                                                                            }

                                                                                                                                            setSelectedKPI(
                                                                                                                                                child
                                                                                                                                            );

                                                                                                                                            setOpenEditModal(
                                                                                                                                                true
                                                                                                                                            );
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        <i className="bi bi-pencil-square text-warning"></i>
                                                                                                                                        <span>
                                                                                                                                            Edit KPI
                                                                                                                                        </span>
                                                                                                                                    </div>
                                                                                                                                </Tooltip>
                                                                                                                            ),
                                                                                                                        },

                                                                                                                        {
                                                                                                                            type: "divider",
                                                                                                                        },

                                                                                                                        {
                                                                                                                            key: "delete",
                                                                                                                            danger: true,
                                                                                                                            disabled:
                                                                                                                                !showDelete,
                                                                                                                            label: (
                                                                                                                                <div className="dropdown-item-premium">
                                                                                                                                    <i className="bi bi-trash3 text-danger"></i>
                                                                                                                                    <span>
                                                                                                                                        Delete KPI
                                                                                                                                    </span>
                                                                                                                                </div>
                                                                                                                            ),

                                                                                                                            onClick:
                                                                                                                                () => {

                                                                                                                                    if (
                                                                                                                                        !showDelete
                                                                                                                                    )
                                                                                                                                        return;

                                                                                                                                    setDeleteKPI(
                                                                                                                                        child
                                                                                                                                    );

                                                                                                                                },
                                                                                                                        },
                                                                                                                    ],
                                                                                                                }}
                                                                                                            >
                                                                                                                <button
                                                                                                                    type="button"
                                                                                                                    className="btn btn-sm btn-light"
                                                                                                                    style={{
                                                                                                                        width: "30px",
                                                                                                                        height: "30px",
                                                                                                                        padding: 0,
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <i className="bi bi-three-dots-vertical"></i>
                                                                                                                </button>
                                                                                                            </Dropdown>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div className="border-top mt-3 pt-3">
                                                                                                        <div className="row g-3">
                                                                                                            <div className="col-6">
                                                                                                                <div className="text-muted small mb-1">
                                                                                                                    Registered During
                                                                                                                </div>
                                                                                                                <span className="badge bg-light-info text-info rounded-pill">
                                                                                                                    {child.Registered_During ||
                                                                                                                        "---"}
                                                                                                                </span>
                                                                                                            </div>

                                                                                                            <div className="col-6">
                                                                                                                <div className="text-muted small mb-1">
                                                                                                                    Measurables
                                                                                                                </div>
                                                                                                                <span className="badge bg-light-info text-info rounded-pill">
                                                                                                                    {child.Measurables ||
                                                                                                                        "---"}
                                                                                                                </span>
                                                                                                            </div>

                                                                                                            <div className="col-12">
                                                                                                                <div className="text-muted small mb-1">
                                                                                                                    Objective
                                                                                                                </div>
                                                                                                                <div className="text-gray-700 fs-7">
                                                                                                                    {childObjective
                                                                                                                        ? childObjective.length >
                                                                                                                            120
                                                                                                                            ? `${childObjective.substring(
                                                                                                                                0,
                                                                                                                                120
                                                                                                                            )}...`
                                                                                                                            : childObjective
                                                                                                                        : "---"}
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        );
                                                                                    }
                                                                                )
                                                                            ) : (
                                                                                <div className="text-center text-muted py-3 fs-7">
                                                                                    No Child KPIs Found
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })
                                                ) : (
                                                    <div className="card border shadow-sm">

                                                        <div className="card-body text-center py-5 text-muted">
                                                            No Department KPIs Found
                                                        </div>

                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>


            {/* Inactive KPI Modal */}
            <Modal
                open={!!deleteKPI}
                centered
                width={420}
                footer={null}
                onCancel={() => setDeleteKPI(null)}
            >
                <div className="text-center">
                    <div
                        style={{
                            width: 70,
                            height: 70,
                            margin: "0 auto",
                            borderRadius: "50%",
                            background: "#fef2f2",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <i
                            className="bi bi-trash3-fill"
                            style={{
                                color: "#dc2626",
                                fontSize: 28,
                            }}
                        />
                    </div>

                    <h4 className="mt-4 fw-bold">
                        Delete KPI
                    </h4>

                    <p className="text-muted">
                        Are you sure you want to delete
                        <br />
                        <strong>{deleteKPI?.KPIName}</strong>?
                    </p>

                    <div className="d-flex gap-3 mt-4">
                        <button
                            className="btn btn-light flex-fill btn-sm"
                            onClick={() => setDeleteKPI(null)}
                            disabled={deleteLoading}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn btn-danger flex-fill btn-sm"
                            onClick={handleDeleteKPI}
                            disabled={deleteLoading}
                        >
                            {deleteLoading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                    Deleting...
                                </>
                            ) : (
                                <>
                                    <i className="bi bi-trash3 me-2"></i>
                                    Delete
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </Modal>

            <style>
                {`
                /* =========================================================
                   TOP BAR — Create KPI button
                ========================================================= */

                .kpi-actions { margin-left: auto; }

                .premium-btn-primary {
                    display: inline-flex;
                    align-items: center;
                    gap: 10px;
                    padding: 10px 18px;
                    border: none;
                    border-radius: 14px;
                    background: linear-gradient(135deg, #2563eb 0%, #4f46e5 100%);
                    color: #fff;
                    font-size: 14px;
                    font-weight: 600;
                    letter-spacing: .3px;
                    box-shadow: 0 10px 20px rgba(37, 99, 235, .25);
                    transition: all .25s ease;
                }

                .premium-btn-primary:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 14px 28px rgba(37, 99, 235, .35);
                    background: linear-gradient(135deg, #1d4ed8 0%, #4338ca 100%);
                    color: #fff;
                }

                .premium-btn-primary:active { transform: scale(.98); }

                .premium-btn-primary:focus {
                    outline: none;
                    box-shadow: 0 0 0 .2rem rgba(79, 70, 229, .2);
                }

                .premium-btn-primary i { color: #fff; }

                .premium-btn-icon {
                    width: 28px;
                    height: 28px;
                    border-radius: 8px;
                    background: rgba(255, 255, 255, .18);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 14px;
                }


                /* =========================================================
                   ORGANIZATION KPI — header
                ========================================================= */

                .organization-kpi-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 20px;
                }

                .organization-kpi-title { flex: 1; }

                .organization-kpi-search {
                    width: 280px;
                    min-width: 280px;
                }


                /* =========================================================
                   DEPARTMENT KPI — header + view toggle
                ========================================================= */

                .department-kpi-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 24px;
                }

                .department-kpi-title {
                    flex: 1;
                    min-width: 0;
                }

                .department-kpi-search {
                    width: 320px;
                    min-width: 320px;
                }

                .kpi-view-toggle {
                    display: flex;
                    align-items: center;
                    padding: 4px;
                    background: #f3f6fa;
                    border: 1px solid #e3e9f1;
                    border-radius: 12px;
                    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.04);
                }

                .kpi-toggle-btn {
                    border: none;
                    background: transparent;
                    padding: 9px 16px;
                    border-radius: 9px;
                    color: #6c757d;
                    font-size: 13px;
                    font-weight: 600;
                    white-space: nowrap;
                    cursor: pointer;
                    transition: all 0.25s ease;
                }

                .kpi-toggle-btn:hover { color: #0d6efd; }

                .kpi-toggle-btn.active {
                    background: #ffffff;
                    color: #0d6efd;
                    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
                    font-weight: 700;
                }

                .kpi-toggle-btn i { font-size: 14px; }

                .department-kpi-entries {
                    min-height: 45px;
                    border-radius: 6px;
                }


                /* =========================================================
                   DEPARTMENT KPI — parent table
                ========================================================= */

                .department-parent-table-scroll {
                    overflow-x: auto;
                    -webkit-overflow-scrolling: touch;
                }

                .department-parent-table-scroll table { min-width: 1050px; }

                .kpi-row { border-left: 4px solid transparent; }
                .kpi-row.accent-primary { border-left-color: var(--bs-primary); }
                .kpi-row.accent-success { border-left-color: var(--bs-success); }
                .kpi-row.accent-info    { border-left-color: var(--bs-info); }
                .kpi-row td { vertical-align: middle; }

                .avatar-square { width: 32px; height: 32px; font-size: .85rem; }
                .avatar-circle { width: 32px; height: 32px; }
                .chevron-btn   { width: 32px; height: 32px; }


                /* =========================================================
                   DEPARTMENT KPI — child table
                ========================================================= */

                .child-kpi-wrapper {
                    width: 100%;
                    background: #fff;
                    border: 1px solid #e9edf5;
                    border-radius: 12px;
                    padding: 18px;
                    margin: 8px;
                    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
                }

                .child-header {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 4px;
                    padding: 10px 5px 15px;
                    margin-bottom: 15px;
                    font-size: 15px;
                    font-weight: 700;
                    color: #0d6efd;
                }

                .child-kpi-table-scroll {
                    overflow-x: auto;
                    -webkit-overflow-scrolling: touch;
                }

                .child-kpi-table-scroll table { min-width: 1020px; }

                .child-kpi-wrapper thead { background: #f8faff; }

                .child-kpi-wrapper thead th {
                    font-size: 12px;
                    color: #7b8794;
                    text-transform: uppercase;
                    border-bottom: 1px solid #edf2f7;
                }

                .child-kpi-wrapper tbody tr { border-bottom: 1px solid #f3f4f6; }

                .child-kpi-wrapper tbody tr:last-child { border-bottom: none; }

                /* Objective tooltip (rich text) */
                .quill-tooltip-content {
                    max-width: 400px;
                    max-height: 250px;
                    overflow-y: auto;
                }

                .quill-tooltip-content p { margin-bottom: 5px; }

                .quill-tooltip-content ul,
                .quill-tooltip-content ol {
                    padding-left: 20px;
                    margin-bottom: 5px;
                }


                /* =========================================================
                   ROW ACTIONS — ⋮ button + dropdown
                ========================================================= */

                .action-menu-btn {
                    width: 38px;
                    height: 38px;
                    border: none;
                    border-radius: 12px;
                    background: #f8fafc;
                    color: #64748b;
                    transition: .25s;
                }

                .action-menu-btn:hover {
                    background: #2563eb;
                    color: #fff;
                    transform: translateY(-2px);
                    box-shadow: 0 8px 20px rgba(37, 99, 235, .25);
                }

                .premium-dropdown .ant-dropdown-menu {
                    border-radius: 14px;
                    padding: 8px;
                    box-shadow: 0 10px 35px rgba(15, 23, 42, .15);
                }

                .dropdown-item-premium {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    min-width: 130px;
                    font-weight: 500;
                }

                .dropdown-item-premium i {
                    width: 18px;
                    font-size: 16px;
                }


                /* =========================================================
                   MOBILE  (≤ 767px — only the mobile header/card views
                   are visible here; the desktop tables are d-none)
                ========================================================= */

                @media (max-width: 767.98px) {

                    .kpi-actions {
                        width: 100%;
                        margin-left: 0;
                    }

                    .kpi-actions .premium-btn-primary {
                        width: 100%;
                        justify-content: center;
                    }

                    /* Organization header */
                    .organization-kpi-header {
                        flex-direction: column;
                        align-items: stretch;
                        gap: 12px;
                    }

                    .organization-kpi-title { width: 100%; }

                    .organization-kpi-title h3 {
                        font-size: 18px;
                        line-height: 1.4;
                        margin-bottom: 0 !important;
                    }

                    .organization-kpi-search {
                        width: 100%;
                        min-width: 100%;
                    }

                    /* Department header */
                    .department-kpi-header {
                        flex-direction: column;
                        align-items: stretch;
                        gap: 14px;
                    }

                    .department-kpi-title { width: 100%; }

                    .department-kpi-title h6 {
                        font-size: 16px;
                        line-height: 1.4;
                    }

                    .department-kpi-title small {
                        display: block;
                        font-size: 12px;
                        line-height: 1.5;
                    }

                    .department-kpi-title nav {
                        font-size: 12px;
                        margin-top: 8px !important;
                    }

                    .department-kpi-title nav .mx-2 {
                        margin-left: 6px !important;
                        margin-right: 6px !important;
                    }

                    .department-kpi-search {
                        width: 100%;
                        min-width: 100%;
                    }

                    .department-kpi-search .form-control {
                        height: 40px;
                        font-size: 13px;
                    }

                    .department-kpi-search .input-group-text { height: 40px; }
                }


                /* =========================================================
                   SMALL MOBILE  (≤ 480px)
                ========================================================= */

                @media (max-width: 480px) {

                    .organization-kpi-title h3 { font-size: 16px; }

                    .department-kpi-header-card { margin-bottom: 12px !important; }

                    .department-kpi-header-card .card-body { padding: 12px !important; }

                    .department-kpi-title h6 { font-size: 15px; }

                    .department-kpi-title small { font-size: 11px; }

                    .department-kpi-search .form-control { font-size: 12px; }
                }
                `}
            </style>

            <KpiModal
                open={openCreateKPI}
                onCancel={() => setOpenCreateKPI(false)}
                onSave={handleSaveKPI}
                activeTab={activeTab}
                departments={departments}
                uomTypes={uomTypes}
                managerKpis={managerKpis}
                selectedParentId={selectedParentKPIId}
                selectedParentUOMId={selectedParentUOMId}
                loading={saving}
                depts={departments}
                selectedMainDept={selectedMainDept}
                title={
                    activeTab === "organization"
                        ? "Create Organization KPI"
                        : "Create Department KPI"
                }
            />

            <KpiEditModal
                open={openEditModal}
                onCancel={() => setOpenEditModal(false)}
                onSave={handleUpdateKPI}
                kpiData={selectedKPI}
                activeTab={activeTab}
                departments={departments}
                uomTypes={uomTypes}
                managerKpis={managerKpis}
                loading={saving}
                depts={departments}
                selectedMainDept={selectedMainDept}
                title={
                    activeTab === "organization"
                        ? "Edit Organization KPI"
                        : "Edit Department KPI"
                }
            />
        </Base1>
    )
}